import axios from "@/assets/js/httpUtil.js";
import { baseUrl, cDomain } from "./env";

// 获取基本信息 - 体检信息
export const getExamInfo = (params) => {
  return axios.get(
    cDomain +
      "/cms/healthArchive/2.0/healtUserDocRecord/getUserDocRecordDetailByProfileId",
    {
      params,
    }
  );
};
// 获取基本信息 - 生活方式
export const getLifeStyle = (params) => {
  return axios.get(
    cDomain + "/cms/healthArchive/2.0/healthValue_B/getUserModuleDoc",
    {
      params,
    }
  );
};
// 获取服务使用记录
export const getOrder = (params) => {
  return axios.get(cDomain + "/api/user/order", {
    params,
  });
};
// 获取体检报告记录
export const getExamList = (params) => {
  return axios.get(cDomain + "/api/exam/list", {
    params,
  });
};
// 获取用户问卷记录基本信息-底部问卷入口是否显示
export const getEvaluationState = (params) => {
  return axios.get(cDomain + "/api/user/hdays", {
    params,
  });
};
// 获取用户中台Id
export const getUserProfileId = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/user/getUserProfileId", {
    params,
  });
};

// 获取用户是否进入健康值首页
export const getUserEntrance = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/user/getUserEntrance", {
    params,
  });
};

// 获取用户了解度
export const getUserUnderstandRate = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getUserUnderstandRate",
    {
      params,
    }
  );
};

// 获取用户了解度详情
export const getUserUnderstandRateDetail = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getUserUnderstandRateDetail",
    {
      params,
    }
  );
};

// 获取健康档案信息
export const getArchive = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHValueInfo", {
    params,
  });
};

// 获取健康档案信息  - changcheng
export const getArchiveToB = (params) => {
  return axios.get(
    cDomain + "/cms/healthArchive/2.0/healthValue/getHValueInfoToB",
    {
      params,
    }
  );
};

// 获取健康档案数据项选项getOrder
export const getArchiveOption = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHValueDataOption", {
    params,
  });
};

// 提交健康档案用户信息
export const saveArchive = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/saveBatchHealthDocRecord",
    {
      params,
    }
  );
};

// 获取用户了解度任务
export const getUserUnderstandTask = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getUserUnderstandTask",
    {
      params,
    }
  );
};

// 首页获取用户健康值接口
export const getHValueDetail = (params) => {
  return axios.get(
    cDomain + "/cms/healthArchive/2.0/healthValue/getHValueDetail",
    {
      params,
    }
  );
};

// 首页获取用户历史趋势
export const getUserHValueHistory = (params) => {
  return axios.get(
    cDomain + "/cms/healthArchive/2.0/healthValue/getUserHValueHistory",
    {
      params,
    }
  );
};

// 首页获取用户风险
export const getDiseaseRisk = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getHDiseaseRiskEstimate",
    {
      params,
    }
  );
};

// 首页获取用户问题
export const getProblem = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHRiskFactorIssue", {
    params,
  });
};

// 首页获取用户问题风险因素
export const getProblemDetail = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/healthValue/getHRiskFactorList", {
    params,
  });
};

// 首页获取用户异常指标
export const getAnomalyIndex = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getHDiseaseExceptionList",
    {
      params,
    }
  );
};

// 首页获取用户异常指标
export const getHDetail = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getHDiseaseExceptionList",
    {
      params,
    }
  );
};

// 获取健康档案单疾病风险详情接口
export const getDiseaseDetail = (params) => {
  return axios.get(
    baseUrl + "/hplatform/2.0/healthValue/getRValueDiseaseInfo",
    {
      params,
    }
  );
};

// 更新用户问卷完成情况
export const updateUserTaskStatus = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/user/updateUserTaskStatus", {
    params,
  });
};

// 更新首页每月测评
export const updateUserMonthTask = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/user/updateUserTaskNew", {
    params,
  });
};

// 获取配置信息
export const getConfig = (params) => {
  return axios.get(baseUrl + "/hplatform/2.0/app/getAppTheme", {
    params,
  });
};
